export const AUTHENTICATE_REQUEST = 'AUTHENTICATE_REQUEST';

export const authenticateRequest = (username, password) => ({
    type: AUTHENTICATE_REQUEST,
    payload: { username, password },
});
